import { sample } from 'effector';
import { signout } from '@features/common';
import { $openedId } from '../../detail-sdui-opened-id/model';
import { RelatedTicketsGate } from '../model/main';
import {
  $showEnterMessageToApplicant,
  fxSendMessageToApplicant,
  messageForm,
  setShowEnterMessageToApplicant,
} from '../model/message-to-applicant';

$showEnterMessageToApplicant
  .on(setShowEnterMessageToApplicant, (_, status) => status)
  .reset([RelatedTicketsGate.close, signout]);

sample({
  clock: messageForm.submitted,
  source: $openedId,
  fn: (id, { text }) => ({ id: id!, text }),
  target: fxSendMessageToApplicant,
});
